/*
 * @Author: LiJunLei 2826904107@qq.com
 * @Date: 2022-11-05 15:43:27
 * @LastEditors: LiJunLei 2826904107@qq.com
 * @LastEditTime: 2022-12-12 16:11:16
 * @FilePath: \emergency-h5\src\api\request\planManagement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import requests from '../request'

// 预案管理 演习演练列表
export const drillSelectList = (data) => {
  return requests({
    url: '/api/drill/selectList',
    method: 'post',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习演练增
export const drillAdd = (data) => {
  return requests({
    url: `/api/drill/add`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习演练删改
export const drillUpdate = (data) => {
  return requests({
    url: `/api/drill/update`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习事件列表
export const drillEventList = (data) => {
  return requests({
    url: '/api/drillEvent/list',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习事件增
export const drillEventInsert = (data) => {
  return requests({
    url: `/api/drillEvent/insert`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习事件改
export const drillEventUpdate = (data) => {
  return requests({
    url: `/api/drillEvent/update`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 预案管理 演习事件删
export const drillEventDelete = (data) => {
  return requests({
    url: `/api/drillEvent/delete`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 获取标签列表
export async function getLabelList(params) {
	return requests({
		url: '/api/label/getLabelList',
		method: 'get',
		params,
		headers: {
			'Contont-type': 'application/json',

		}
	})
}
